/**
 * The alias of window.getSelection.
 *
 * @since 0.1.0
 *
 * @return A Selection instance.
 */
export function getSelection(): Selection {
  return window.getSelection();
}
